<template>
  <div class="mirco-app-report preview">
    <micro-app
      :name="microName"
      :url="getUrl"
      iframe
      router-mode="native"
      baseroute="/microLsp/outPage"
      :data="storeInfo"
      keep-alive
      @datachange="handleDataChange"
    ></micro-app>
  </div>
</template>
<script lang="ts">
declare global {
  interface Window {
    eventCenterForAppNameVite: any;
  }
}

import microApp, { EventCenterForMicroApp } from '@micro-zoe/micro-app';

import config from '@/config/user.env';
import { useStore } from 'vuex';
import { defineComponent, nextTick, reactive, ref, toRefs, watch, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { handleMicroBigDataTrack } from '@/utils/bigLogData/trackHelper';

// // 因为vite子应用关闭了沙箱，我们需要为子应用appname-vite创建EventCenterForMicroApp对象来实现数据通信
window.eventCenterForAppNameVite = new EventCenterForMicroApp('ams');

export default defineComponent({
  setup() {
    const microName = 'ams';
    const storeInfo = ref({});
    const state = reactive({
      router: {},
      user: null,
      authority: null,
      currentTenant: null,
      appId: null,
      appList: null,
      btnPermissions: null,
      supplier: null,
      applicationCode: null,
    });

    const route = useRoute();
    const router = useRouter();

    watch(route, (val) => {
      initPage();
    });

    const store = useStore();
    const getUrl = computed(() => {
      return config.microAmsUrl;
    });
    const initPage = () => {
      const routeInfo = microApp.router.current.get(microName);
      if (routeInfo && microApp.router.decode(route.path).includes(microName)) {
        if (`/#${route.path}` !== routeInfo.fullPath) {
          nextTick(() => {
            microApp.setData(microName, { path: route.path });
          });
        }
      }

      state.router = router; // 假设 router 是从 useRouter 获取的
      state.user = store.getters.user; // 从 Vuex 获取用户信息
      state.authority = store.getters.authority;
      state.currentTenant = store.getters.currentTenant;
      state.appId = store.getters.appId;
      state.appList = store.getters.appList;
      state.btnPermissions = store.getters.btnPermissions;
      state.applicationCode = store.getters.applicationCode;

      const { user, authority, currentTenant, appId, appList, btnPermissions, applicationCode } = toRefs(state);
      // 这里的一些参数除了重点说明的两个一般物流的项目都会有;
      storeInfo.value = {
        type: 'updateData',
        router,
        user,
        authority,
        currentTenant,
        appId,
        appList,
        btnPermissions,
        applicationCode,
        toNtp,
      };
    };

    const toNtp = () => {
      router.push('/ntp/mod/pdt/find-vehicles?ntp=/#/mod/pdt/find-vehicles');
    };

    onMounted(() => {
      // 记得修改子应用 id
      // microApp.setData(microName, { path: route.path, query: route.query || {} });
      initPage();
    });
    const handleDataChange = (val: any) => {
      const data = val.detail.data;
      if (handleMicroBigDataTrack(data, route.path)) return;
    };

    return {
      microName,
      storeInfo,
      config,
      getUrl,
      handleDataChange,
    };
  },
  // computed: {
  //   ...mapGetters([
  //     'user',
  //     'authority',
  //     'visitedViews',
  //     'currentTenant',
  //     'appId',
  //     'tenantInfo',
  //     'appList',
  //     'btnPermissions',
  //   ]),
  // },
});
</script>
<style lang="less">
.mirco-app-report {
  height: 100%;

  micro-app[name='ams'] {
    width: 100%;
    height: 100%;
    .root-panel {
      height: 100%;
    }
    .problem-list-manage {
      .flex-layout-column {
        box-sizing: border-box;
      }
    }

    .ams-layout .md-button.md-button--primary {
      background-color: #4285f5;
      color: #fff;
      border-color: #409eff;
    }
    .ams-layout .md-button.md-button--text {
      color: #0077ff;
    }
    .md-pagination.is-background .md-pager li:not(.disabled).active {
      background-color: #4285f5;
      border: solid 1px #4285f5;
    }
  }
}

micro-app {
  height: 100%;
}
</style>
